"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.pseudoStyles=exports.inputStyles=exports.default=void 0;var _styledComponents=_interopRequireWildcard(require("styled-components")),_chromaJs=_interopRequireDefault(require("chroma-js"));function _interopRequireDefault(a){return a&&a.__esModule?a:{default:a}}function _interopRequireWildcard(a,b){if("function"==typeof WeakMap)var c=new WeakMap,d=new WeakMap;return(_interopRequireWildcard=function(a,b){if(!b&&a&&a.__esModule)return a;var e,g,h={__proto__:null,default:a};if(null===a||"object"!=typeof a&&"function"!=typeof a)return h;if(e=b?d:c){if(e.has(a))return e.get(a);e.set(a,h)}for(const c in a)"default"!=c&&{}.hasOwnProperty.call(a,c)&&((g=(e=Object.defineProperty)&&Object.getOwnPropertyDescriptor(a,c))&&(g.get||g.set)?e(h,c,g):h[c]=a[c]);return h})(a,b)}const pseudoStyles=exports.pseudoStyles=(0,_styledComponents.css)`
  outline: 0;
  transition: border-color 0.3s cubic-bezier(0.16, 1, 0.3, 1),
    box-shadow 0.3s cubic-bezier(0.16, 1, 0.3, 1),
    opacity 0.3s cubic-bezier(0.16, 1, 0.3, 1),
    background-color 0.3s cubic-bezier(0.16, 1, 0.3, 1);
  &:not(:disabled) {
    &:focus {
      border: 1px solid
        ${a=>{let{theme:b,colour:c,custom_colour:d}=a;const e=d||b[c]||b.primary;return(0,_chromaJs.default)(e).alpha(.5)}};
      box-shadow: 0 0 0 0.2rem
        ${a=>{let{theme:b,colour:c,custom_colour:d}=a;const e=d||b[c]||b.primary;return(0,_chromaJs.default)(e).alpha(.25)}};
    }
    &:active {
      box-shadow: none;
    }
  }
`,inputStyles=exports.inputStyles=(0,_styledComponents.css)`
  ${{borderRadius:".25rem",borderWidth:"1px",borderStyle:"solid","--tw-border-opacity":"1",borderColor:"rgb(229 231 235 / var(--tw-border-opacity, 1))","--tw-bg-opacity":"1",backgroundColor:"rgb(243 244 246 / var(--tw-bg-opacity, 1))",outline:"2px solid transparent",outlineOffset:"2px"}}
  box-sizing: border-box;
  font-size: 0.875rem;
  padding: calc(0.5rem - 1px) calc(0.75rem - 1px);
  &::placeholder {
    ${{"--tw-text-opacity":"1",color:"rgb(107 114 128 / var(--tw-text-opacity, 1))"}}
  }
  &:disabled {
    ${{cursor:"not-allowed",opacity:"0.75"}}
  }
  &:not(:disabled) {
    &:hover {
      box-shadow: 0 0 0 0.2rem
        ${a=>{let{theme:b,colour:c,custom_colour:d}=a;const e=d||b[c]||b.primary;return(0,_chromaJs.default)(e).alpha(.25)}};
    }
  }
  ${a=>a.readOnly&&{borderStyle:"none",backgroundColor:"transparent",padding:"0"}}
`,TextInput=_styledComponents.default.input.withConfig({displayName:"TextInput",componentId:"sc-1qky7k1-0"})([""," "," ",""],{display:"block",width:"100%"},inputStyles,pseudoStyles);var _default=exports.default=TextInput;